// EditSupplierDrawer.js
import React, { useEffect } from "react"
import { Drawer, Form, Input, Select, Button, Space, message, Row, Col, Switch } from "antd"
import { doc, setDoc, serverTimestamp } from "firebase/firestore"

const { TextArea } = Input

export default function EditSupplierDrawer({ open, onClose, supplier, dbInstance }) {
  const [form] = Form.useForm()

  useEffect(() => {
    if (supplier) {
      form.setFieldsValue({
        company: supplier.company || "",
        name: supplier.name || "",
        email: supplier.email || "",
        phone: supplier.phone || "",
        country: supplier.country || "Latvia",
        legalAddress: supplier.legalAddress || "",
        legalCity: supplier.legalCity || "",
        legalPC: supplier.legalPC || "",
        deliveryAddress: supplier.deliveryAddress || "",
        deliveryCity: supplier.deliveryCity || "",
        deliveryPC: supplier.deliveryPC || "",
        reg: supplier.reg || "",
        vat: supplier.vat || "",
        bankName: supplier.bankName || "",
        bankCode: supplier.bankCode || "",
        accountNumber: supplier.accountNumber || "",
        invoicePrefix: supplier.invoicePrefix || "",
        logoUrl: supplier.logoUrl || "",
        comment: supplier.comment || "",
        active: !(supplier?.active === false),
      })
    } else {
      form.resetFields()
    }
  }, [supplier, form])

  const onFinish = async (values) => {
    if (!supplier?.id) return
    try {
      const payload = {
        ...values,
        active: values.active, // boolean
        updatedAt: serverTimestamp(),
      }
      await setDoc(doc(dbInstance, "suppliers", supplier.id), payload, { merge: true })
      message.success("Supplier updated.")
      onClose?.()
    } catch (e) {
      console.error(e)
      message.error("Failed to update supplier.")
    }
  }

  return (
    <Drawer
      title={`Edit Supplier${supplier?.company ? ` – ${supplier.company}` : ""}`}
      open={open}
      width={600}
      onClose={() => onClose?.()}
      destroyOnClose
      extra={
        <Space>
          <Button onClick={() => onClose?.()}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()}>
            Save
          </Button>
        </Space>
      }>
      <Form form={form} style={{ width: "100%" }} layout="vertical" onFinish={onFinish}>
        <Form.Item label="Active" name="active" valuePropName="checked">
          <Switch />
        </Form.Item>

        <Form.Item
          label="Company"
          name="company"
          rules={[{ required: true, message: "Company is required" }]}>
          <Input allowClear />
        </Form.Item>

        <Form.Item label="Contact Person" name="name">
          <Input allowClear />
        </Form.Item>

        <Row gutter={12}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ type: "email", message: "Invalid email" }]}>
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="Phone" name="phone">
              <Input allowClear />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={12}>
          <Col xs={24} md={12}>
            <Form.Item label="REG" name="reg">
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="VAT" name="vat">
              <Input allowClear />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="Country" name="country">
          <Select
            options={[
              { value: "Latvia", label: "Latvia" },
              { value: "Lithuania", label: "Lithuania" },
              { value: "Estonia", label: "Estonia" },
              { value: "Poland", label: "Poland" },
              { value: "Other", label: "Other" },
            ]}
          />
        </Form.Item>

        <Form.Item label="Legal Address" name="legalAddress">
          <Input allowClear />
        </Form.Item>

        <Row gutter={12}>
          <Col xs={24} md={12}>
            <Form.Item label="Legal City" name="legalCity">
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="Legal PC" name="legalPC">
              <Input allowClear />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="Delivery Address" name="deliveryAddress">
          <Input allowClear />
        </Form.Item>

        <Row gutter={12}>
          <Col xs={24} md={12}>
            <Form.Item label="Delivery City" name="deliveryCity">
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="Delivery PC" name="deliveryPC">
              <Input allowClear />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={12}>
          <Col xs={24} md={12}>
            <Form.Item label="Bank Name" name="bankName">
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="Bank Code (BIC/SWIFT)" name="bankCode">
              <Input allowClear />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="Account (IBAN)" name="accountNumber">
          <Input allowClear />
        </Form.Item>

        <Form.Item label="Invoice Prefix" name="invoicePrefix">
          <Input allowClear />
        </Form.Item>

        <Form.Item label="Logo URL" name="logoUrl">
          <Input allowClear />
        </Form.Item>

        <Form.Item label="Comment" name="comment">
          <TextArea rows={3} allowClear />
        </Form.Item>
      </Form>
    </Drawer>
  )
}
